import ThinkingAnimation from "components/ThinkingAnimation";

const GlassCardLoader = () => (
  <ThinkingAnimation size="sm" containerHeight={350} />
);

export default GlassCardLoader;
